// Get/Set accessToken In-memory

const listeners: ((token: string | null) => void)[] = [];

export const setDeviceToken = (token: string | null): void => {
	if (token) {
		localStorage.setItem("device-token", token);
	} else {
		localStorage.removeItem("device-token");
	}

	listeners.forEach(x => x(token));
};

export const getDeviceToken = (): string | null => {
	return localStorage.getItem("device-token");
};

export const subscribeToDeviceToken = (callback: (token: string | null) => void): void => {
	listeners.push(callback);
};
